import React, { memo } from "react";
import { RightSideBar } from "@jutro/router";
var AppFloorPlanRightSideInternal = function (_ref) {
  var _ref$rightSideProps = _ref.rightSideProps,
    rightSideProps = void 0 === _ref$rightSideProps ? {} : _ref$rightSideProps,
    isLowerThanDesktop = _ref.isLowerThanDesktop,
    componentMap = _ref.componentMap,
    collapsible = rightSideProps.collapsible,
    isInitiallyCollapsed = rightSideProps.isInitiallyCollapsed,
    _rightSideProps$sides = rightSideProps.sides,
    sides = void 0 === _rightSideProps$sides ? [] : _rightSideProps$sides,
    shouldFocusAfterRender = rightSideProps.shouldFocusAfterRender;
  return React.createElement(RightSideBar, {
    collapsible: collapsible || isLowerThanDesktop,
    isInitiallyCollapsed: isInitiallyCollapsed || isLowerThanDesktop,
    sides: sides,
    componentMap: componentMap,
    expandOverContent: isLowerThanDesktop,
    shouldFocusAfterRender: shouldFocusAfterRender
  });
};
AppFloorPlanRightSideInternal.displayName = "AppFloorPlanRightSide";
export var AppFloorPlanRightSide = memo(AppFloorPlanRightSideInternal);
AppFloorPlanRightSideInternal.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "AppFloorPlanRightSide",
  props: {
    rightSideProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
}, AppFloorPlanRightSideInternal.__docgenInfo = {
  componentName: "AppFloorPlanRightSide",
  packageName: "@jutro/floorplan",
  description: "",
  displayName: "AppFloorPlanRightSide",
  methods: [],
  actualName: "AppFloorPlanRightSideInternal",
  props: {
    rightSideProps: {
      defaultValue: {
        value: "{}",
        computed: !1
      },
      required: !1
    }
  }
};